<div class="all-content">
    <div class="top">
        {{ getLanguages('pages/screens/administrator/clipboard') }}
    </div>

    <div class="row">    
        <div class="div-search">
            <div class="search">
                <input type="text" [(ngModel)]="searchText" (keyup.enter)="search()">
            </div>
            <button (click)="search()">
                {{ getLanguages('search') }}
            </button>
        </div>   
    </div>

    <span class="title-clipboard">
        {{ getLanguages('clipboard/title') }}
        <i class="fas fa-circle-question" matTooltip="{{ getLanguages('clipboard/description') }}"></i>
    </span>  

    <div class="nodes">
        <div class="node" *ngFor="let item of getDisplayedRows()">
            <div>
                <i class="fas" [ngClass]="{'fa-handshake': item.node.crmTree, 'fa-folder-tree': !item.node.crmTree}"></i>
                <span>
                    {{item.corporation.corporation_name}} - {{ item.node.label }}
                </span>
            </div>

            <div class="save" [matMenuTriggerFor]="selectExport" *ngIf="getSystemPermission('clipboard', 'link')">
                {{ getLanguages('clipboard/send_to') }}
                <i class="fas fa-angle-down"></i>
            </div>
            <mat-menu #selectExport="matMenu">
                <button (click)="copyToCookie(item.node, 'business_solutions')" class="menu-button">
                    {{ getLanguages('clipboard/send_to_business_solutions') }}
                </button>
                <button (click)="copyToCookie(item.node, 'crm_tree')" class="menu-button">
                    {{ getLanguages('clipboard/send_to_crm_tree') }}
                </button>
            </mat-menu>
        </div>
        <div class="loading" *ngIf="isLoading">
            <section>
                <div class="loading-spinner"></div>
                <span class="span"> 
                    {{ getLanguages('loading') }}
                </span>
            </section>
        </div>
    
        <div class="noData" *ngIf="filteredDatasource.data.length == 0 && !isLoading">
            <div class="icon">
                <i class="fa-solid fa-exclamation"></i>
            </div>
            <span>
                {{ getLanguages('errors/noData')}}
            </span>
        </div>
    </div>
    
    <div class="div-paginator" *ngIf="filteredDatasource.data.length > 0 && !isLoading">
        <div class="paginator">
            <span>
                {{ getLanguages('businessSolution/modal/strategy/itensPage') }}
            </span>
            <button [matMenuTriggerFor]="menu" class="itens-per-page">
                {{ itemsPerPage }}
            </button>
            <mat-menu #menu="matMenu" >
                <button mat-menu-item (click)="choseItemsPage(10)">10</button>
                <button mat-menu-item (click)="choseItemsPage(20)">20</button>
                <button mat-menu-item (click)="choseItemsPage(30)">30</button>
            </mat-menu>
            <span>
                {{ getLanguages('businessSolution/modal/strategy/totalPages') }}
            </span>
            <span class="totalPages" >
                {{ getTotalPages()}}
            </span>
            <button [ngClass]="currentPage === 1 ? 'disabled-arrow' : 'arrow' " [disabled]="currentPage === 1 || isLoading" (click)="onPageChange(currentPage - 1)">
                <i class="fa-solid fa-angle-left"></i>
            </button>
            <input type="number" [(ngModel)]="currentPageReq" (keydown)="checkValue($event)" disabled>
            <button [ngClass]="currentPage == getTotalPages() ? 'disabled-arrow' : 'arrow' "  [disabled]="currentPage == getTotalPages() || isLoading" (click)="onPageChange(currentPage + 1)">
                <i class="fa-solid fa-angle-right"></i>
            </button>
        </div>
    </div>
    
</div>
